module.exports = __webpack_public_path__ + "static/assets/02aabb5fe5596dc08a2d0385b38d57bd.gif";